export enum ActivationStatusType {
  active = 1,
  inactive= 2,
}

export const ActivationStatusTypeDisplay: {[key in ActivationStatusType]: string} = {
  [ActivationStatusType.active]: "Activated",
  [ActivationStatusType.inactive]: "Deactivated",
}